import { addListener } from '../common';

export const onWorkspaceMembersRefetch = addListener<{
  refetch: boolean;
}>('/workspace/refetch');

export const onWorkspaceLeft = addListener<{
  user: { _id: string; workspace: string };
}>('/workspace/left');
